export const localRouter_meun_free = [ //产业研究大脑导航栏顺序

    {
        code: "R",
        switch: true,
        name: "产业研究-行业报告库",
        oldtext: "产业研究",
        type: "yjbg",
        url: "researchIndex", 
        open: true,
        icontype: "el-icon-s-management",
        children: [
            {
                code: "R-WLCY",
                switch: true,
                name: "",
                oldtext: "未来产业",
                url: "/report?type="+'w0',
                reportId: 'w0',
            },{
                code: "R-SZJJ",
                switch: true,
                name: "",
                oldtext: "数字经济",
                url: "/report?type=10005",
                reportId: 10005,
            },
            {
                code: "R-GDZZ",
                switch: true,
                name: "",
                oldtext: "高端制造",
                url: "/report?type=10014",
                reportId: 10014,
            },
            {
                code: "R-NYHBCL",
                switch: true,
                name: "",
                oldtext: "能源环保材料",
                url: "/report?type=10024",
                reportId: 10024,
            },
            // {
            //     code: "R-DJK",
            //     switch: true,
            //     name: "",
            //     oldtext: "大健康",
            //     url: "/report?type=10001",
            //     reportId: 10001,
            // },
            {
                code: "R-XDFWY",
                switch: true,
                name: "",
                oldtext: "现代服务业",
                url: "/report?type=10018",
                reportId: 10018,
            },
            {
                code: "R-DXF",
                switch: true,
                name: "",
                oldtext: "大消费",
                url: "/report?type=10029",
                reportId:10029 ,
            },
            {
                code: "R-JJYTZ",
                switch: true,
                name: "",
                oldtext: "基建与投资",
                url: "/report?type=10034",
                reportId: 10034,
            },
            {
                code: "R-DJK",
                switch: true,
                name: "",
                oldtext: "大健康",
                url: "/report?type=10001",
                reportId: 10001,
            },
            // {code:"R-YDBG",switch:true,name:"",oldtext:"月度报告",url:"/report?type=10055",reportId:10055, },

            // {
            //     code: "R-BGQK",
            //     switch: true,
            //     name: "",
            //     oldtext: "报告全库",
            //     url: "/report?type=0",
            //     newType: ""
            // },
            // {
            //     code: "R-QYTZDTBG",
            //     switch: true,
            //     name: "",
            //     oldtext: "企业投资动态报告",
            //     url: "freeReport",
            //     reportId: 10006, 
            // },
        ],
    },
    {
        code: "L",
        switch: true,
        name: "产业链研究-产业图谱",
        oldtext: "产业链研究",
        type: "cylyj",
        url: "/allchain?bc=10561",
        open: true,
        icontype: "el-icon-s-management",
        children: [{
            code: "L-SZJJ",
            switch: true,
            name: "",
            oldtext: "数字经济",
            url: "/allchain?bc=10561"
        },
        {
            code: "L-GDZZ",
            switch: true,
            name: "",
            oldtext: "高端制造",
            url: "/allchain?bc=10562"
        },
        {
            code: "L-NYHBCL",
            switch: true,
            name: "",
            oldtext: "能源环保材料",
            url: "/allchain?bc=10563"
        },
        {
            code: "L-DJK",
            switch: true,
            name: "",
            oldtext: "大健康",
            url: "/allchain?bc=10560"
        },
        {
            code: "L-XDFWY",
            switch: true,
            name: "",
            oldtext: "现代服务业",
            url: "/allchain?bc=10637"
        },
        {
            code: "L-DXF",
            switch: true,
            name: "",
            oldtext: "大消费",
            url: "/allchain?bc=10644"
        },
        {
            code: "B-DDTP",
            switch: true,
            name: "",
            oldtext: "当地产业链",
            url: "/localChainList",
        },
        {
            code: "B-CYSJK",
            switch: true,
            name: "产业数据库",
            oldtext: "产业数据库",
            url: "/industryLibrary",
            newType:""
        },
        // {
        // 	code:"B-BSTP",
        // 	switch:true,
        // 	name:"",
        // 	oldtext:"本省产业链",
        // 	url:"/localChainList?type=province",
        // 	},	
    ],
    },
    //产业招商
    {
        code: "A",
        switch: true,
        name: "",
        oldtext: "重点企业研究",
        type: "cyzs",
        url: "/enterpriseList?type=9&Pt=1",
        open: true,
        morebtn: false,
        icontype: "el-icon-menu",
        children: [{
                code: "A-LTQY",
                switch: true,
                name: "",
                oldtext: "龙头企业库",
                url: "/enterpriseList?type=9&Pt=1"
            },
            {
                code: "A-KCQY",
                switch: true,
                name: "",
                oldtext: "科创企业库",
                url: "/enterpriseList?type=2&Pt=2"
            },
            {
                code: "A-QBNZQY",
                switch: true,
                name: "",
                oldtext: "全部内资企业库",
                url: "/totalEnterprises"
            },
            {
                code: "A-JWSSQY",
                switch: true,
                name: "",
                oldtext: "境外上市企业",
                url: "/foreignEnterprises"
            },
            {
                code: "A-WZQY",
                switch: true,
                name: "",
                oldtext: "外资企业库",
                url: "/forcapEnterprise"
            },
            // {
            //     code: "A-ZSDT",
            //     switch: true,
            //     name: "",
            //     oldtext: "数字地图",
            //     url: "/enterprise-mapsearch"
            // },
            {
                code: "A-KYJG",
                switch: true,
                name: "",
                oldtext: "研发机构",
                url: "/innovative-resources"
            },
            
            {
                code: "T-TZJG",
                switch: true,
                name: "",
                oldtext: "投资机构",
                url: "/investment-institutions"
            },
            {
                code: "A-XHSH",
                switch: true,
                name: "",
                oldtext: "协会商会",
                url: "/associationList"
            },
            {
                code: "A-ZYZ",
                switch: true,
                name: "",
                oldtext: "专业镇",
                url: "/professionalTown",
            },
        ]
    },
   
    // 投资动态 从投资大脑搬移
    {
        code: "T",
        switch: true,
        name: "产业动态跟踪",
        oldtext: "产业动态跟踪",
        type: "cydt",
        url: "/investment-clues3",
        open: true,
        icontype: "el-icon-view",
        children: [{
                code: "T-CXQYRZ",
                switch: true,
                name: "",
                oldtext: "创新企业融资",
                url: "/investment-clues3"
            },
            {
                code: "T-BGQYND",
                switch: true,
                name: "",
                oldtext: "上市公司投资",
                url: "/markenterprise"
            },
            {
                code: "T-LTQYND",
                switch: true,
                name: "",
                oldtext: "企业拿地投资",
                url: "/landenterprise"
            },
            // {
            //     code: "T-HYTZDT",
            //     switch: true,
            //     name: "",
            //     oldtext: "产业资讯动态",
            //     url: "/industryInvestment"
            // },
            {
                code: "B-CYZC",
                switch: true,
                name: "",
                oldtext: "政策库",
                url: "/policylibrary"
            },
            {
                code: "C-QYTZCK",
                switch: true,
                name: "",
                oldtext: "企业投资窗口",
                url: "/enterpriseInvestmentWindow",
            },
            {
                code: "C-CYTZCK",
                switch: true,
                name: "",
                oldtext: "产业投资窗口",
                url: "/industryInvestmentWindow",
            }, 
            // {
            //     code: "B-TZXMK",
            //     switch: true,
            //     name: "",
            //     oldtext: "投资项目库",
            //     url: "invest"
            // },
            // {
            //     code: "B-NDXMK",
            //     switch: true,
            //     name: "",
            //     oldtext: "拿地项目库",
            //     url: "land"
            // },
        ],
    },
    {
        code: "J",
        switch: true,
        name: "区域竞争力研究",
        oldtext: "城市竞争力研究",
        type: "qyjzl",
        url: "/regional-competitiveness",
        open: true,
        icontype: "el-icon-s-management",
        children: [{
            code: "J-SSJZL",
            switch: true,
            name: "",
            oldtext: "省市竞争力研究",
            url: "/regional-competitiveness?type=1", 
            // newType:"NEW"
        },{
            code: "J-CSJZL",
            switch: true,
            name: "",
            oldtext: "城市竞争力研究",
            url: "/regional-competitiveness?type=2", 
            // newType:"NEW"
        }, 
        ],},
    // 智能推荐 拆分出来的细节页面 
    {
        code: "C",
        switch: true,
        name: "产业排行榜",
        oldtext: "产业排行榜",
        type: "cyphb",
        url: "/investment-clues7",
        openicon: true,
        open: true,
        icontype: "el-icon-view",
        children: [{
                code: "C-ZDCYZDCS",
                switch: true,
                name: "",
                oldtext: "重点产业城市排行",
                url: "/investment-clues7"
            },
            {
                code: "C-RDCYQYPH",
                switch: true,
                name: "",
                oldtext: "热点产业企业排行",
                url: "/investment-clues5"
            },
            {
                code: "C-ZDCSZDCY",
                switch: true,
                name: "",
                oldtext: "重点城市产业排行",
                url: "/investment-clues6"
            },
            {
                code: "C-ZDQYQYPH",
                switch: true,
                name: "",
                oldtext: "重点区域企业排行",
                url: "/investment-clues1"
            },
            {
                code: "C-YZSSGSPH",
                switch: true,
                name: "",
                oldtext: "上市公司排行榜",
                url: "/investment-clues4"
            },
            {
                code: "C-QYTZPH",
                switch: true,
                name: "",
                oldtext: "企业投资排行榜",
                url: "/investment-clues8"
            },
        ],
    },
    {
        code: "J",
        switch: true,
        name: "",
        oldtext: "本地投资趋势",
        url: "/localInvestAnalysis?type=1",
        open: true,
        morebtn: false,
        icontype: "el-icon-s-order",
        children: [{
                code: "J-BSXZTZFX",
                switch: true,
                name: "",
                oldtext: "本省新增投资分析",
                url: "/localInvestAnalysis?type=1",
                // newType: "New",
            },
            {
                code: "J-BS-XZTZFX",
                switch: true,
                name: "",
                oldtext: "本市新增投资分析",
                url: "/localInvestAnalysis?type=2",
                // newType: "New",
            },
        ]
    },
    //关系计算器
    {
        code: "E",
        switch: true,
        name: "",
        oldtext: "关系计算器",
        url: "/enterprisesCityRelation",
        open: false,
        openicon: true,
        morebtn: false,
        icontype: "el-icon-s-platform",
        children: [{
                code: "E-QY－CSGXJSQ",
                switch: true,
                name: "",
                oldtext: "企业-城市 关系计算器",
                url: "/enterprisesCityRelation",
                newType: "HOT",
            },
            {
                code: "E-GXJSQ",
                switch: true,
                name: "",
                oldtext: "企业-企业 关系计算器",
                url: "/relationalcalculator"
            },
            {
                code: "E-ZZDT",
                switch: true,
                name: "",
                oldtext: "作战地图",
                url: "/targetMap",
            },
            {
                code: "E-WDGXW",
                switch: true,
                name: "",
                oldtext: "我的关系网",
                url: "/userrelational"
            },
        ]
    },
    //工作台
    {
        code: "E",
        switch: true,
        name: "",
        oldtext: "工作台",
        url: "/workbench",
        open: false,
        openicon: true,
        morebtn: false,
        icontype: "el-icon-s-cooperation",
        children: [{
                code: "E-MBQY",
                switch: true,
                name: "",
                oldtext: "目标企业",
                url: "/focusenterprises"
            },
            {
                    code: "E-DBQY",
                    switch: true,
                    name: "",
                    oldtext: "企业对比",
                    url: "/enterprise-compare",
                    newType:'',
                },
            {
                code: "E-TJFX",
                switch: true,
                name: "",
                oldtext: "统计分析",
                url: "/statisticalAnalysis"
            },
            {
                code: "E-XMGL",
                switch: true,
                name: "",
                oldtext: "项目管理",
                url: "/projectmanagement"
            },
            {
                code: "E-GJJL",
                switch: true,
                name: "",
                oldtext: "跟进记录",
                url: "/followuprecord"
            },
            {
                code: "E-DBJL",
                switch: true,
                name: "",
                oldtext: "待办记录",
                url: "/todolist"
            },
        ]
    },
    //个人中心
    {
        code: "F",
        switch: true,
        name: "",
        oldtext: "个人中心",
        url: "/baseInformation",
        open: false,
        openicon: true,
        morebtn: false,
        icontype: "el-icon-s-custom",
        children: [
            // {code:"F-GZLY",switch:false,name:"",oldtext:"关注领域",url:"/userFocus"},
            {
                code: "F-JBZL",
                switch: true,
                name: "",
                oldtext: "基本资料",
                url: "/baseInformation"
            },
            {
                code: "F-MMXG",
                switch: true,
                name: "",
                oldtext: "密码修改",
                url: "/editPassword"
            },
            // {code:"F-FWSC",switch:false,name:"",oldtext:"服务手册",url:"/servicebook"},
            {
                code: "F-TCZH",
                switch: true,
                name: "",
                oldtext: "退出账号",
                url: "loginout"
            },
        ]
    },
]